(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["adeqo-language-selector"] && !Shopify.designMode) return;
  try {
    (function () {
  // De kiezer staat meerdere keren in de DOM: desktop-header, mobiel menu,
  // zoek-drawer, account-modal, winkelwagen-drawer en footer. Daarom
  // querySelectorAll en per instantie binden.
  function init() {
    var selectors = document.querySelectorAll('.adeqo-language-selector');
    if (!selectors.length) return;

    var triggers = [];

    function sluitAlles(behalve) {
      triggers.forEach(function (t) {
        if (t !== behalve) t.setAttribute('aria-expanded', 'false');
      });
    }

    Array.prototype.forEach.call(selectors, function (selector) {
      if (selector.dataset.adqLangBound) return;
      var trigger = selector.querySelector('.adeqo-language-selector__trigger');
      // De eentalige variant is een statische div zonder uitklap: overslaan.
      if (!trigger || trigger.classList.contains('adeqo-language-selector__trigger--static')) return;
      selector.dataset.adqLangBound = '1';
      triggers.push(trigger);

      trigger.addEventListener('click', function (e) {
        e.stopPropagation();
        var open = trigger.getAttribute('aria-expanded') === 'true';
        sluitAlles(trigger);
        trigger.setAttribute('aria-expanded', open ? 'false' : 'true');
      });

      // Accordeon: één land tegelijk open.
      var rows = selector.querySelectorAll('.adeqo-language-selector__country');
      Array.prototype.forEach.call(rows, function (row) {
        var toggle = row.querySelector('.adeqo-language-selector__country-toggle');
        var group = row.querySelector('.adeqo-language-selector__languages');
        if (!toggle || !group) return;
        toggle.addEventListener('click', function () {
          var wasOpen = toggle.getAttribute('aria-expanded') === 'true';
          Array.prototype.forEach.call(rows, function (other) {
            var t = other.querySelector('.adeqo-language-selector__country-toggle');
            var g = other.querySelector('.adeqo-language-selector__languages');
            if (!t || !g) return;
            t.setAttribute('aria-expanded', 'false');
            g.hidden = true;
            other.classList.remove('is-open');
          });
          if (!wasOpen) {
            toggle.setAttribute('aria-expanded', 'true');
            group.hidden = false;
            row.classList.add('is-open');
          }
        });
      });

      // De taalknop draagt de taal als submit-waarde; het land gaat via het
      // verborgen veld, gevuld bij de klik (die gaat vóór de submit).
      var countryInput = selector.querySelector('input[name="country_code"]');
      if (countryInput) {
        Array.prototype.forEach.call(selector.querySelectorAll('[data-country]'), function (btn) {
          btn.addEventListener('click', function () {
            countryInput.value = btn.dataset.country;
          });
        });
      }

      // Escape sluit, ongeacht waar de focus binnen de kiezer staat.
      selector.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' || e.key === 'Esc') {
          trigger.setAttribute('aria-expanded', 'false');
          trigger.focus();
        }
      });
    });

    // Eén gedelegeerde listener voor buitenklikken.
    document.addEventListener('click', function (e) {
      triggers.forEach(function (t) {
        var wrap = t.closest('.adeqo-language-selector');
        if (wrap && !wrap.contains(e.target)) t.setAttribute('aria-expanded', 'false');
      });
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
  } catch(e) { console.error(e); }
})();

})();
